export default function EmptyPageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="text-default bg-surface h-fit min-h-screen max-w-screen px-5 font-normal">
      <div className="wrap-anywhere flex size-full grow flex-col gap-8 py-8 sm:px-10">
        {children}
      </div>
    </div>
  );
}
